import { FilledIconButton } from "../FilledIconButton"

export function MoreButton(props) {

    const {
        color,
        size,
        icon,
        onClick,
    } = props

    const Icon = icon

    return <FilledIconButton id="linear-edit-button" color={color} size={size} onClick={onClick}>
        <Icon fontSize={size} />
    </FilledIconButton>
}